import ElementInfo from './ElementInfo'
export default ElementInfo
